import { render, staticRenderFns } from "./upgradeContract.vue?vue&type=template&id=25cd5b65&scoped=true"
import script from "./upgradeContract.vue?vue&type=script&lang=js"
export * from "./upgradeContract.vue?vue&type=script&lang=js"
import style0 from "./upgradeContract.vue?vue&type=style&index=0&id=25cd5b65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd5b65",
  null
  
)

export default component.exports